import React, { useEffect, useState } from 'react';
import { SelectMenu, Button, toaster } from 'evergreen-ui';
import PropTypes from 'prop-types';
import { api } from '../../../services/api';

const UserFilter = ({ user, setUser, disabled, prefix }) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([
    { label: 'All', value: 'all' },
  ]);

  async function fetchData() {
    setLoading(true);
    try {
      const { data } = await api.users.list(1, 1000, null, true);
      setOptions([
        ...options,
        ...data.data.filter((u) => u.enabled).map((u) => ({ label: u.name, value: u.id })),
      ]);
      setLoading(false);
    } catch (error) {
      toaster.danger('Error occured while loading "Type filter" data');
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (opt) => {
    if (setUser) {
      setUser(opt.value);
    }
  };

  // Only show active if the filter exists and it is not "All"
  const showActive = () => user && user !== options[0].value;

  return (
    <SelectMenu
      hasTitle={false}
      options={options}
      selected={user}
      onSelect={(v) => handleChange(v)}>

      <Button
        size="small"
        disabled={disabled || loading}
        appearance={showActive() ? 'primary' : 'default'}>
        {prefix}
        :
        {' '}
        {
          // eslint-disable-next-line eqeqeq
          !loading && user && options.length > 1 ? options.find((opt) => opt.value == user).label : 'All'
        }
      </Button>
    </SelectMenu>
  );
};

UserFilter.propTypes = {
  user: PropTypes.number,
  setUser: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
};

UserFilter.defaultProps = {
  disabled: false,
  prefix: 'User',
};

export default UserFilter;
